import { apiFetch } from "./api";

export interface PriceData {
	symbol: string;
	base: string;
	price: string;
	source?: string;
	fetched_at?: string;
}

export async function fetchKrwRate(): Promise<number> {
	const data = await apiFetch<PriceData>("/v1/price", { method: "GET" });
	if (data.base !== "KRW") {
		throw new Error(`KRW rate unexpected base: ${data.base}`);
	}
	const rate = Number(data.price);
	if (!Number.isFinite(rate) || rate <= 0) {
		throw new Error(`KRW rate invalid number: ${data.price}`);
	}
	return rate;
}
